<template>
  <div class="manage_page">
    <h1>Welcome to chenxi's App</h1>
    <p>This is the Manage Page of llmbot.</p>
  </div>
</template>

<script>
export default {
  name: 'ManagePage',
  data() {
    return {
      // 可以在这里添加数据
    }
  }
}
</script>

<style scoped>
.manage_page {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
h1 {
  color: #42b983;
}
</style>